// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-table-header[data-v-957d8b78]{color:#9e9e9e;border-bottom:1px solid #9e9e9e}.base-table-row[data-v-957d8b78]{font-weight:300;border-bottom:1px solid #bdbdbd}.base-table-row--clickable[data-v-957d8b78]{cursor:pointer}.base-table-row--clickable[data-v-957d8b78]:hover{background:rgba(0,0,0,.04)}", ""]);
// Exports
module.exports = exports;
